import EPubTableContainer from './EPubTableContainer';
import EPubFetchData from "./services/EPubFetchData";
import EPubDeleteData from "./services/EPubDeleteData";
import EPubSyncData from "./services/EPubSyncData";
import EPubSyncAllData from "./services/EPubSyncAllData";
import EPubFeatureData from "./services/EPubFeatureData";
import stores from './stores';

const ePubTable = {
  path: ['/epubs'],
  exact: true,
  services: [new EPubFetchData(), new EPubDeleteData(), new EPubSyncData(), new EPubSyncAllData(), new EPubFeatureData()],
  stores: stores,
  component: EPubTableContainer,
};

export default ePubTable;
